import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/inactive/Breadcrumb";
import TransactionByUserLayer from "../../components/TransactionByUserLayer";

const TransactionByUserPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Invoice - List" />

        {/* TransactionByUserLayer */}
        <TransactionByUserLayer />
      </MasterLayout>
    </>
  );
};

export default TransactionByUserPage;
